module.exports = __webpack_public_path__ + "img/i_arena_TOP_on.65ac921.png";